import { motion } from "framer-motion";

import Block3Columns from "../../components/Block3Columns";
import ImageContainer from "../../components/ImageContainer";
import Block2ColumnsText from "../../components/Block2ColumnsText";
import MasonryGallery from "../../components/MasonryGallery";
import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import {
  BookOpen,
  Users,
  Globe,
  Lightbulb,
  Award,
  Search,
  TrendingUp,
  Heart,
  Download,
  Video,
  FileText,
  HelpCircle,
  Mail,
  Phone,
  ArrowRight,
  ChevronRight,
  MapPin,
  PartyPopper,
  Shirt,
  QrCode,
  GraduationCap,
  Sparkles,
  User,
  Leaf,
  Compass,
  CheckCircle,
  ShieldCheck,
  Info,
} from "lucide-react";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/1091cdc7-2587-4084-8747-94d92e148dec" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

function ActividadesExtracurriculares() {
  const [activeTab, setActiveTab] = useState("carrera"); // 'carrera' | 'institucionales'

  const DataDisplay = ({ data }) => (
    <div>
      <ImageContainer
        src={data.imagen_portada}
        content={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      >
        {" "}
      </ImageContainer>

      <div className="max-w-2xl m-auto text-center pt-20 pb-20">
        <div className="inline-flex items-center space-x-2 bg-[#004270]  border border-blue-400/30 px-3 py-1.5 rounded-full text-amber-400 text-xs font-bold uppercase tracking-wider mb-2">
          <Sparkles className="w-4 h-4 animate-pulse" />
          <span>Formación Integral • Más allá del aula</span>
        </div>

        <div
          dangerouslySetInnerHTML={{
            __html: data.bloque1,
          }}
        />
      </div>

      {/* Competencias Section */}
      <section
        id="competencias"
        className="py-20 bg-slate-50 border-b border-slate-100"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-8 space-y-4">
            <span className="text-xs font-bold text-[#0F2C59] tracking-widest uppercase bg-blue-100/60 px-3 py-1.5 rounded-full">
              Ejes De Crecimiento
            </span>
          </div>

          <div
            className="text-center w-full md:w-[75%] lg:w-[50%] m-auto mb-12 text-slate-700"
            dangerouslySetInnerHTML={{
              __html: data.bloque2,
            }}
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {/* Competencia 1: Desarrollo personal integral */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-amber-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <TrendingUp size={24} className="text-amber-500" />
                </div>
                <div
                  className="mb-2 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque3,
                  }}
                />
              </div>
            </motion.div>

            {/* Competencia 2: Trabajo colaborativo */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <Users size={24} className="text-blue-600" />
                </div>
                <div
                  className="mb-2 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque4,
                  }}
                />
              </div>
            </motion.div>

            {/* Competencia 3: Innovación y emprendimiento */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-yellow-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <Lightbulb size={24} className="text-yellow-500" />
                </div>
                <div
                  className="mb-2 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque5,
                  }}
                />
              </div>
            </motion.div>

            {/* Competencia 4: Mentalidad sostenible */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-emerald-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <Leaf size={24} className="text-emerald-600" />
                </div>
                <div
                  className="mb-2 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque6,
                  }}
                />
              </div>
            </motion.div>

            {/* Competencia 5: Ciudadanía global */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-cyan-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <Globe size={24} className="text-cyan-600" />
                </div>
                <div
                  className="mb-2 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </div>
            </motion.div>

            {/* Competencia 6: Reconocimiento Formativo */}
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-purple-200 hover:shadow-md transition-all duration-300 h-full flex flex-col justify-start">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-5 text-[#0F2C59] shadow-inner">
                  <Award size={24} className="text-purple-600" />
                </div>
                <div
                  className="mb-2 
                      [&_a]:text-purple-600
    [&_a]:font-medium
    [&_a]:underline
    [&_a]:underline-offset-4
    [&_a]:transition-colors
    [&_a]:duration-300
    hover:[&_a]:text-purple-700
                  
                  [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque8,
                  }}
                />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section
        id="tipos"
        className="py-24 bg-slate-100/80 border-y border-slate-200/50"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="text-center max-w-2xl mx-auto mb-16 space-y-4">
            <span className="text-xs font-bold text-[#0F2C59] tracking-widest uppercase bg-blue-100 px-3 py-1.5 rounded-full">
              Estructura Del Programa
            </span>
            <div
              className="text-center  "
              dangerouslySetInnerHTML={{
                __html: data.bloque9,
              }}
            />
          </div>

          {/* Interactive Tab Selectors */}
          <div className="flex justify-center mb-12">
            <div className="bg-white p-1.5 rounded-2xl shadow-md border border-slate-200 flex space-x-2 w-full max-w-lg">
              <button
                onClick={() => setActiveTab("carrera")}
                className={`flex-1 py-3.5 px-4 rounded-xl text-sm font-bold transition-all flex items-center justify-center space-x-2 ${
                  activeTab === "carrera"
                    ? "bg-[#0F2C59] text-white shadow-md shadow-blue-900/10"
                    : "text-slate-500 hover:text-slate-900 hover:bg-slate-50"
                }`}
              >
                <BookOpen className="w-4 h-4" />
                <span>AEC de Carrera</span>
              </button>

              <button
                onClick={() => setActiveTab("institucionales")}
                className={`flex-1 py-3.5 px-4 rounded-xl text-sm font-bold transition-all flex items-center justify-center space-x-2 ${
                  activeTab === "institucionales"
                    ? "bg-[#0F2C59] text-white shadow-md shadow-blue-900/10"
                    : "text-slate-500 hover:text-slate-900 hover:bg-slate-50"
                }`}
              >
                <Compass className="w-4 h-4" />
                <span>AEC Institucionales</span>
              </button>
            </div>
          </div>

          {/* Tab Content Box */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -15 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-3xl border border-slate-200 p-8 md:p-12 shadow-xl shadow-slate-200/50 items-center"
            >
              {/* Tab Left Detail */}
              <div>
                {/* Features Checklist */}
                <div className="space-y-4 pt-2">
                  <div>
                    {activeTab === "carrera" ? (
                      <>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.bloque10,
                          }}
                        />
                      </>
                    ) : (
                      <>
                        {" "}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: data.bloque11,
                          }}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </section>
      {/*certifica tus logros */}

      <section className="py-20 bg-slate-50 border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className=" text-center mb-8 space-y-4">
            <span className="text-xs font-bold text-[#0F2C59] tracking-widest uppercase bg-blue-100/60 px-3 py-1.5 rounded-full">
              Reconocimiento de la participación
            </span>
          </div>

          <div
            className="text-center w-full md:w-[75%] lg:w-[50%] m-auto mb-12 text-slate-700"
            dangerouslySetInnerHTML={{
              __html: data.bloque12,
            }}
          />

          <div className=" gap-6 ">
            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
              className="mb-4"
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all duration-300 h-full flex items-start justify-between gap-6">
                <div
                  className="flex-1 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque13,
                  }}
                />

                <div className="w-12 h-12 shrink-0 bg-blue-50 rounded-xl flex items-center justify-center text-[#0F2C59] shadow-inner">
                  <Award size={24} className="text-amber-600" />
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
              className="mb-4"
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all duration-300 h-full flex items-start justify-between gap-6">
                <div
                  className="flex-1 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque14,
                  }}
                />

                <div className="w-12 h-12 shrink-0 bg-blue-50 rounded-xl flex items-center justify-center text-[#0F2C59] shadow-inner">
                  <ShieldCheck size={24} className="text-red-600" />
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
              className="mb-4"
            >
              <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:border-blue-200 hover:shadow-md transition-all duration-300 h-full flex items-start justify-between gap-6">
                <div
                  className="flex-1 [&_h4]:text-lg [&_h4]:font-bold [&_h4]:text-[#0F2C59] [&_p]:text-slate-500 [&_p]:text-sm"
                  dangerouslySetInnerHTML={{
                    __html: data.bloque15,
                  }}
                />

                <div className="w-12 h-12 shrink-0 bg-blue-50 rounded-xl flex items-center justify-center text-[#0F2C59] shadow-inner">
                  <Info size={24} className="text-cyan-600" />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => <DataDisplay data={data} />}
    </DataFetcherTemplateHome2>
  );
}

export default ActividadesExtracurriculares;
